import Component from '../core/Component'

const STATES = {
    ACTIVE: 'is-active',
    READY: 'is-ready'
}
export default class LangSwitch extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            trigger: null,
        }

        this.timer = null
    }

    prepare() {
        this.ref.trigger.addEventListener('click', this.handleTriggerClick)
        this.element.addEventListener('mouseenter', this.handleMouseEnter)
        this.element.addEventListener('mouseleave', this.handleMouseLeave)
        this.element.classList.add(STATES.READY)
    }

    destroy() {
        clearTimeout(this.timer)
    }

    handleTriggerClick = (event) => {
        event.preventDefault()

        this.toggle()
    }

    handleMouseEnter = () => {
        this.enter()
    }

    handleMouseLeave = () => {
        this.leave()
    }

    enter() {
        this.element.classList.add(STATES.ACTIVE)
    }

    leave() {
        this.element.classList.remove(STATES.ACTIVE)
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.leave()
        } else {
            this.enter()
        }
    }
}
